/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentSaveViewModel } from "../types/IndividualPaymentSaveViewModel.ts";
import { individualPaymentEditorAddressViewModelSchema } from "./individualPaymentEditorAddressViewModelSchema.ts";
import { individualPaymentSaveDiscountViewModelSchema } from "./individualPaymentSaveDiscountViewModelSchema.ts";

export const individualPaymentSaveViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  courseRegistrationId: z.optional(z.number().int()),
  courseFinancialId: z.optional(z.number().int()),
  description: z.string().nullish(),
  additionalInformation: z.string().nullish(),
  discountPunctualPercentage: z.number().nullish(),
  expirationDate: z.optional(z.number().int()),
  scholarshipStatus: z.number().int().nullish(),
  scholarshipTypeId: z.number().int().nullish(),
  scholarshipReason: z.string().nullish(),
  automaticGenerateInvoice: z.optional(z.boolean()),
  numberParcels: z.optional(z.number().int()),
  observation: z.string().nullish(),
  totalValue: z.optional(z.number()),
  totalValueWithoutValueTransfer: z.optional(z.number()),
  valueTransfer: z.optional(z.number()),
  valueRegistration: z.number().nullish(),
  generateEnrollmentParcel: z.optional(z.boolean()),
  payAsCompany: z.optional(z.boolean()),
  paymentMethod: z.optional(z.number().int()),
  discountScholarshipPercentage: z.number().nullish(),
  thirdPayment: z.optional(z.boolean()),
  thirdName: z.string().nullish(),
  thirdDocument: z.string().nullish(),
  thirdEmail: z.string().nullish(),
  thirdPhone: z.string().nullish(),
  countryCodeThirdPhone: z.string().nullish(),
  thirdCode: z.string().nullish(),
  companyName: z.string().nullish(),
  companyContactName: z.string().nullish(),
  companyContactEmail: z.string().nullish(),
  companyContactPhone: z.string().nullish(),
  countryCodeCompanyContact: z.string().nullish(),
  cnpj: z.string().nullish(),
  ie: z.string().nullish(),
  ieFree: z.optional(z.boolean()),
  financialAssociatedCompanyId: z.number().int().nullish(),
  paymentReceiptType: z.number().int().nullish(),
  hidePaymentPlan: z.optional(z.boolean()),
  appropriateRegister: z.optional(z.boolean()),
  updatePlanParcels: z.optional(z.boolean()),
  discounts: z
    .array(z.lazy(() => individualPaymentSaveDiscountViewModelSchema))
    .nullish(),
  thirdAddress: z.optional(
    z.lazy(() => individualPaymentEditorAddressViewModelSchema),
  ),
}) as unknown as ToZod<IndividualPaymentSaveViewModel>;
